import { render, staticRenderFns } from "./TeachersDetail.vue?vue&type=template&id=3d69d585"
import script from "./TeachersDetail.vue?vue&type=script&lang=js"
export * from "./TeachersDetail.vue?vue&type=script&lang=js"
import style0 from "./TeachersDetail.vue?vue&type=style&index=0&id=3d69d585&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports